import ShadowBox from './ShadowBox';

export { ShadowBox };
